import gql from "graphql-tag";

export const TRACKER_SUMMARY_QUERY = gql`
  query userEventSessions($userId: ID) {
    userVideoLogs(userId: $userId, last: 10, eventId_Isnull: false) {
      edges {
        node {
          id
          date
          lastView
          duration
          event {
            id
            name
            instructor {
              id
              firstName
              lastName
            }
            eventType {
              id
              category
            }
          }
        }
      }
    }
    workoutBlockWorkoutLogs(subscriptionBlock_UserId: $userId, last: 10) {
      edges {
        node {
          id
          startDate
          heartRate
          effort
          calories
          image
          unitActivity {
            id
            type
            activity {
              id
              title
            }
          }
        }
      }
    }
    restDays(userId: $userId, last: 10) {
      edges {
        node {
          id
          restDayDate
          didRest
          coachComment
        }
      }
    }

    nutritionLog(userId: $userId, last: 10) {
      edges {
        node {
          id
          rating
          isNutritiousDay
          meal
          image
          date
          recipe {
            id
            title
            image
          }
        }
      }
    }
    activities(userId: $userId, orderBy: "-startDate", first: 10, startDate_Isnull: false) {
      edges {
        node {
          id
          rating
          calories
          heartRate
          startDate
          seconds
          status
          distance
          averagePace
          effort
          isCustom
          activityType
          image
          action {
            id
            workout {
              id
              name
              label
            }
          }
          type {
            id
            name
            category
          }
          guidedRun {
            id
            name
            published
            category
          }
          event {
            id
            name
            eventType {
              id
              name
              category
            }
            thumbnail
            url
            scheduledDate
            duration
            description
            createdAt
            instructor {
              id
              firstName
              lastName
            }
          }
          workout {
            id
            name
            label
          }
        }
      }
    }
  }
`;
